module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-drawer', {
    attrs: {
      "title": "详情",
      "visible": _vm.visible,
      "direction": "rtl",
      "before-close": _vm.handleClose,
      "custom-class": "c-drawer",
      "wrapperClosable": false,
      "size": "45%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "formRef",
    attrs: {
      "model": _vm.info,
      "label-width": "120px",
      "label-position": "right",
      "size": "small",
      "rules": _vm.formRules
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "code",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "code",
      "clearable": "",
      "disabled": _vm.codeDisabled
    },
    model: {
      value: (_vm.info.code),
      callback: function($$v) {
        _vm.$set(_vm.info, "code", $$v)
      },
      expression: "info.code"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-item-desc"
  }, [_c('span', [_vm._v("code是唯一的，不允许重复")]), _vm._v(" "), _c('span', [_vm._v("A0001 原厂电池折扣")]), _vm._v(" "), _c('span', [_vm._v("A0002 原厂屏幕折扣")]), _vm._v(" "), _c('span', [_vm._v("A0003 三方电池折扣")]), _vm._v(" "), _c('span', [_vm._v("A0004 三方屏幕折扣")]), _vm._v(" "), _c('span', [_vm._v("B开头的且为数字的权益 优惠券相关权益")])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "名称",
      "clearable": ""
    },
    model: {
      value: (_vm.info.name),
      callback: function($$v) {
        _vm.$set(_vm.info, "name", $$v)
      },
      expression: "info.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "激活的Icon",
      "prop": "activeIcon"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "权益icon URL",
      "clearable": ""
    },
    model: {
      value: (_vm.info.activeIcon),
      callback: function($$v) {
        _vm.$set(_vm.info, "activeIcon", $$v)
      },
      expression: "info.activeIcon"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "未激活的Icon",
      "prop": "inactiveIcon"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "权益icon URL",
      "clearable": ""
    },
    model: {
      value: (_vm.info.inactiveIcon),
      callback: function($$v) {
        _vm.$set(_vm.info, "inactiveIcon", $$v)
      },
      expression: "info.inactiveIcon"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权益Value",
      "prop": "value"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "权益Value",
      "clearable": ""
    },
    model: {
      value: (_vm.info.value),
      callback: function($$v) {
        _vm.$set(_vm.info, "value", $$v)
      },
      expression: "info.value"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-item-desc"
  }, [_c('span', [_vm._v("权益折扣则为数值，0.8=8折")]), _vm._v(" "), _c('span', [_vm._v("优惠券则为优惠券ID")])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权益数量",
      "prop": "quantity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "权益数量",
      "clearable": "",
      "min": "0",
      "max": "100000"
    },
    model: {
      value: (_vm.info.quantity),
      callback: function($$v) {
        _vm.$set(_vm.info, "quantity", $$v)
      },
      expression: "info.quantity"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-item-desc"
  }, [_c('span', [_vm._v("折扣权益则是，折扣次数")]), _vm._v(" "), _c('span', [_vm._v("优惠券权益则是，送N张优惠券")])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权益描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "权益描述",
      "clearable": ""
    },
    model: {
      value: (_vm.info.description),
      callback: function($$v) {
        _vm.$set(_vm.info, "description", $$v)
      },
      expression: "info.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n      折扣定价\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "rl"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("添加")])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.discountTable,
      "border": "",
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "折扣名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "begin",
      "label": "开始区间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "end",
      "label": "结束区间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "discount",
      "label": "折扣"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false,
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditDiscount(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-divider', {
          attrs: {
            "direction": "vertical"
          }
        }), _vm._v(" "), _c('el-link', {
          attrs: {
            "type": "danger",
            "underline": false,
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteDiscount(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.searchForm.pageNum,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.searchForm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.searchForm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "editOpera-seat"
  }), _vm._v(" "), _c('div', {
    staticClass: "drawer-footer"
  }, [_c('div', {
    staticClass: "operation"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('privilege-discount', {
    ref: "discountRef",
    on: {
      "refresh": _vm.loadPrivilegeDiscount
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-04fda4e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/privilege/pool/components/info.vue
// module id = 1569
// module chunks = 0